import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

import { preLoadDefaultProject, projectQueries } from '@/lib/queries/project';
import { userQueries } from '@/lib/queries/user';

import { DangerZone } from './-components/DangerZone';
import { GenerateJwtButton } from './-components/GenerateJWT';
import { InstallSlackApp } from './-components/InstallSlackApp';
import { ProjectManagement } from './-components/ProjectManagement';
import { RegenerateGraph } from './-components/RegenerateGraph';

export const Route = createFileRoute('/_root/configuration/')({
  component: RouteComponent,
  loader: preLoadDefaultProject,
});

function RouteComponent() {
  const mainProject = Route.useLoaderData();
  useSuspenseQuery(projectQueries.default());

  const { data: userData } = useQuery(userQueries.current());
  const superuser = userData?.superuser ?? false;

  return (
    <>
      <div className="flex justify-between w-full">
        <h1 className="text-3xl mb-6 font-medium">
          <FormattedMessage
            id="configuration.title"
            values={{
              projectName: mainProject.name,
            }}
          />
        </h1>
      </div>
      <div className="pl-4 gap-10 flex flex-col pb-8">
        {superuser && (
          <section>
            <div className="mt-1">
              <div>
                <h1 className="text-2xl mb-4">
                  <FormattedMessage id="configuration.regenerateGraph.title" />
                </h1>
              </div>
              <RegenerateGraph mainProject={mainProject} />
            </div>
          </section>
        )}
        <GenerateJwtButton mainProject={mainProject} />
        <InstallSlackApp />
        <ProjectManagement mainProject={mainProject} />
        <DangerZone mainProject={mainProject} />
      </div>
    </>
  );
}
